


export const MyCalendar_START = 'MyCalendar_START';
export const MyCalendar_END = 'MyCalendar_END';
export const MyCalendar_ERROR = 'MyCalendar_ERROR';
export const MyCalendar_SUCCESS = 'MyCalendar_SUCCESS';
export const MyCalendar_FAIL = 'MyCalendar_FAIL';
export const MyCalendarPopUp_SUCCESS = 'MyCalendarPopUp_SUCCESS';
